import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import LocationRedirect from '../routing/LocationRedirect';
import LocationSwitch from '../routing/LocationSwitch';
import Locations from './Locations/Locations';
import SoftpayCallback from './Softpay/SoftpayCallback';
import { isAdyenDevice } from '../utils/isAdyenDevice';

/* TODO: Maintain backward compatibility with the previous route '/softpay-android'.
   The new route is now '/public/softpay-android'.
   Once the updated version of the Android app is released,
   this legacy route can be removed. */

const Main: FC = () => {
  return (
    <Routes>
      <Route path="/locations" element={<Locations />} />
      {!isAdyenDevice() && (
        <>
          <Route path="/softpay" element={<SoftpayCallback />} />
          <Route path="/softpay-android" element={<SoftpayCallback />} />
        </>
      )}
      <Route path="/:locationId/*" element={<LocationSwitch />} />
      <Route path="/" element={<LocationRedirect />} />
    </Routes>
  );
};

export default Main;
